// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import { ArrowRight, Close } from '@e4/ui/src/components/svg';
import type { MenuStructure } from './Menu';

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`;

const MenuContentWrapper = styled.div`
  position: absolute;
  top: 3.25em;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #f3f5f4;
`;

const MenuContentContainer = styled.ul`
  width: 100%;
  background-color: #ffffff;
  justify-content: space-between;
  list-style-type: none;
  padding: 0;
  padding-left: 1.5em;
  margin: 0;
`;

const HeadMenuButton = styled.button`
  display: inline-block;
  background: none;
  border: none;
  font-weight: bold;
  font-family: 'Danske Text v2';
  background-color: #ffffff;
  width: 5em;
  height: 4.25em;
  &:focus {
    outline: 0;
  }
`;

const StyledLine = styled.li`
  width: 100%;
  height: 3em;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: thin solid #f3f5f4;
`;

const MenuButton = styled.a`
  display: flex;
  background: none;
  border: none;
  font-family: 'Danske Text v2';
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const StyledArrowRight = styled(ArrowRight)`
  height: 1em;
  width: 1em;
  padding-right: 1.5em;
`;

const LeftArrow = styled(ArrowRight)`
  height: 1em;
  width: 1em;
  transform: scale(-1, 1);
  margin-right: 0.5em;
`;

const StyledLink = styled.a`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  color: inherit;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
`;

const MenuBack = styled.div`
  background-color: #d7e9f1;
  font-weight: bold;
  width: 100%;
  height: 3em;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 1.5em;
`;

const StyledTitle = styled(StyledLine)`
  font-weight: bold;
`;

const MenuButtonBack = styled(MenuButton)`
  justify-content: flex-start;
`;

type Props = {
  menuData: MenuStructure,
};

type State = {
  selectedMenuContent: any,
  menuOpen: boolean,
};

export class MenuSmall extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedMenuContent: null,
      menuOpen: false,
    };
  }

  onMenuButtonClick = () => {
    const menuOpen = this.state.menuOpen;
    this.setState({ menuOpen: !menuOpen });
  };

  onSelectMenu = (menuToShow: any) => {
    if (this.state.selectedMenuContent === menuToShow) {
      this.setState({ selectedMenuContent: null });
    } else {
      this.setState({ selectedMenuContent: menuToShow });
    }
  };

  renderMenuTitles = () => {
    return (
      <MenuContentContainer>
        {this.props.menuData.menuContent.map((menuContent, index) => (
          <StyledLine key={index}>
            <MenuButton
              selected={menuContent === this.state.selectedMenuContent}
              anySelected={this.state.selectedMenuContent}
              onClick={this.onSelectMenu.bind(this, menuContent)}
            >
              {menuContent.menuItemTitle}
              <StyledArrowRight />
            </MenuButton>
          </StyledLine>
        ))}{' '}
      </MenuContentContainer>
    );
  };

  renderContentLinks = (menuContent: Object) => {
    return (
      <div>
        <MenuBack>
          <MenuButtonBack onClick={this.onSelectMenu.bind(this, null)}>
            <LeftArrow />
            {menuContent.menuItemTitle}
          </MenuButtonBack>
        </MenuBack>
        {menuContent.menuItems.map((menuItem) => (
          <MenuContentContainer key={menuItem.title}>
            <StyledTitle>{menuItem.title}</StyledTitle>
            {menuItem.links.map((link) => (
              <StyledLine key={link.linkTitle}>
                <StyledLink href={link.url}>{link.linkTitle}</StyledLink>
                <StyledArrowRight height={'1em'} width={'1em'} />
              </StyledLine>
            ))}
          </MenuContentContainer>
        ))}
      </div>
    );
  };

  render() {
    return (
      <Container>
        <HeadMenuButton onClick={this.onMenuButtonClick}>
          {this.state.menuOpen ? (
            <Close height={'1.1875em'} width={'1.1875em'} />
          ) : (
            'Menu'
          )}
        </HeadMenuButton>
        {this.state.menuOpen ? (
          <MenuContentWrapper>
            {this.state.menuOpen && this.state.selectedMenuContent !== null
              ? this.renderContentLinks(this.state.selectedMenuContent)
              : this.renderMenuTitles()}
          </MenuContentWrapper>
        ) : null}
      </Container>
    );
  }
}
